import inboxProtoReducer from "./inboxProtoReducer";

const inboxProtoReducers = {
    inboxProto: inboxProtoReducer
}

export default inboxProtoReducers;